const ErrorsService = {
    errors: {} as { [key: string]: boolean },

    addError: function (msg: string): void {
        this.errors[msg] = true;
    },

    deleteError: function (msg: string): void {
        delete this.errors[msg];
    },

    hasError: function (msg: string): boolean {
        return !!this.errors[msg];
    },

    clear: function (): void {
        this.errors = {};
    },
};

export default ErrorsService;